import { useOutletContext } from 'react-router-dom'

import { PerformanceDtosReviewProcessTargetAgreementCompletionStatusEnum } from 'generated/resources/datatable.graphql'

import Filter from 'modules/core/components/Filter'
import i18n from 'modules/core/lib/i18n'

import {
  getSignatureStatusLabel,
  getStatusLabel,
} from 'modules/performance_process/components/agreements/StatusTag'
import {
  useFilter,
  useNewlyAddedFilters,
} from 'modules/performance_process/components/review/show/Filters/context'
import { useNewPerformanceModuleContext } from 'modules/performance_process/pages/ReviewsRootPage'
import { ReviewOverviewOutletContext } from 'modules/performance_process/pages/reviews/show/overview'

const getDocumentSignatureStatuses = (): {
  label: string
  value: PerformanceDtosReviewProcessTargetAgreementCompletionStatusEnum
}[] => [
  {
    label: getSignatureStatusLabel('pending'),
    value: 'haspendingesignaturesagreement',
  },
  {
    label: getSignatureStatusLabel('partially_signed'),
    value: 'haspartiallyesignedagreement',
  },
  {
    label: getSignatureStatusLabel('completed'),
    value: 'hasesignedagreement',
  },
  {
    label: getSignatureStatusLabel('bounced_email'),
    value: 'hasbouncedemailagreement',
  },
  {
    label: getSignatureStatusLabel('declined'),
    value: 'hasdeclinedagreement',
  },
  {
    label: getSignatureStatusLabel('cancelled'),
    value: 'hascancelledagreement',
  },
  {
    label: getSignatureStatusLabel('expired'),
    value: 'hasexpiredagreement',
  },
  {
    label: getSignatureStatusLabel('error'),
    value: 'haserroragreement',
  },
]

export const AgreementStatusFilter = () => {
  const { reviewProcess } = useOutletContext<ReviewOverviewOutletContext>()
  const { value, setValue } = useFilter('agreementStatus')
  const { newlyAddedFilters } = useNewlyAddedFilters()
  const { isAgreementDocumentEnabled } = useNewPerformanceModuleContext()

  if (!reviewProcess.agreementsConfiguration.enabled) return null

  return (
    <Filter.SingleChoice
      label={i18n.t('performance_process.agreements.filters.status.title')}
      value={value}
      options={[
        {
          label: i18n.t('performance_process.agreements.filters.not_initiated'),
          value: 'notinitiated',
        },
        {
          label: getStatusLabel('pending'),
          value: 'haspendingagreement',
        },
        {
          label: getStatusLabel('signed'),
          value: 'hassignedagreement',
        },
        ...(isAgreementDocumentEnabled ? getDocumentSignatureStatuses() : []),
      ]}
      onValueChange={setValue}
      defaultOpen={newlyAddedFilters.includes('agreementStatus')}
    />
  )
}
